import { takeEvery, put, call } from "redux-saga/effects"

import axios from "axios"

import { API_SERVICE_QUERY } from "ApiConfig"

// Login Redux States
import { API_DASHBOARD_GET } from "./actionTypes"
import { Dashboard_SET } from "./actions"
import {jwtDecode} from "jwt-decode"

function* Dashboard() {
  async function API() {
    var client = jwtDecode(localStorage.getItem("authUser"))
    var id = client.client_id

    const response = await axios
      .post(`${API_SERVICE_QUERY}Dashboard`, {
        client_id: id,
        token: JSON.parse(localStorage.getItem("authUser")),
      })
      .then(response => response)
      .catch(err => {
      
        // LoginButtonStatus(dispatch,"a")
      })

    localStorage.setItem("DataDashboard", JSON.stringify(response.data))
    return response.data
  }

  // Login İşleminde Sunucudan Dönen Yanıt
  const datam = yield call(API)

  yield put(Dashboard_SET(datam))
}

function* MyDashboard() {
  yield takeEvery(API_DASHBOARD_GET, Dashboard)
}

export default MyDashboard
